import { round, isValidNum } from '@oliasoft-open-source/units';

export const formatToMillions = (num: number | undefined | null): string | number | undefined => {
  const formated = (num || num === 0) && isValidNum(num) ? num / 1_000_000 : undefined;
  if (formated && formated !== 0 && formated < 0.01) {
    return '< 0.01';
  } else {
    return round(formated, 2);
  }
};
